<template>
  <div
    ref="portfolioModal"
    id="portfolioModal"
    class="modal fade modal-portfolio"
    tabindex="-1"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-md">
      <div class="modal-content">
        <div class="modal-header">
          <h5 v-if="edit" class="modal-title">Update distribution balance</h5>
          <h5 v-else class="modal-title">Add distribution balance</h5>
          <span class="modal-close" @click="closeModal"
            ><img :src="close_icon"
          /></span>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-12 col-md-6">
              <div class="form-group">
                <label>Name of algorithm</label>
                <input
                  v-model="form_portfolio.name"
                  type="text"
                  placeholder="Name"
                  class="form-control"
                />
                <div v-if="$v.form_portfolio.name.$dirty">
                  <b-form-invalid-feedback
                    :state="$v.form_portfolio.name.required"
                  >
                    Required Field
                  </b-form-invalid-feedback>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="form-group">
                <label>Select group</label>
                <Multiselect
                  v-model="form_portfolio.group_token"
                  :hideSelected="true"
                  :options="group_options"
                  class="form-control selector"
                  label="name"
                  placeholder="Select an option"
                  valueProp="token"
                >
                  <template v-slot:caret>
                    <span class="multiselect-caret">
                      <img :src="icon_caret" alt="" />
                    </span>
                  </template>
                </Multiselect>
                <div v-if="$v.form_portfolio.group_token.$dirty">
                  <b-form-invalid-feedback
                    :state="$v.form_portfolio.group_token.required"
                  >
                    Required Field
                  </b-form-invalid-feedback>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <!-- <div v-if="edit" class="col-12 col-md-6">
              <div class="form-group">
                <label>Current balance</label>
                <input
                  v-model="form_portfolio.current_balance"
                  type="number"
                  placeholder="1000"
                  class="form-control"
                />
              </div>
            </div> -->
            <div class="col-12 col-md-6">
              <div class="form-group">
                <label>Connection</label>
                <Multiselect
                  v-model="form_portfolio.exchange_token"
                  :hideSelected="true"
                  :options="connection_options"
                  class="form-control selector"
                  label="name"
                  placeholder="Select an option"
                  valueProp="token"
                >
                  <template v-slot:caret>
                    <span class="multiselect-caret">
                      <img :src="icon_caret" alt="" />
                    </span>
                  </template>
                </Multiselect>
                <div v-if="$v.form_portfolio.exchange_token.$dirty">
                  <b-form-invalid-feedback
                    :state="$v.form_portfolio.exchange_token.required"
                  >
                    Required Field
                  </b-form-invalid-feedback>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6" v-if="!isDemo">
              <div class="form-group">
                <label>Connection NAV</label>
                <input
                  :value="selected_connection_nav"
                  type="text"
                  placeholder="Connection NAV"
                  class="form-control"
                  readonly
                />
              </div>
            </div>
            <div v-if="edit" class="col-12 col-md-6">
              <div class="form-group">
                <label>Portfolio NAV</label>
                <input
                  :value="form_portfolio.nav"
                  type="text"
                  placeholder="Connection NAV"
                  class="form-control"
                  readonly
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-6">
              <div class="form-group">
                <label>Type</label>
                <Multiselect
                  v-model="form_portfolio.type"
                  :hideSelected="true"
                  :options="typesOptions"
                  class="form-control selector"
                  label="name"
                  placeholder="Select an option"
                  valueProp="value"
                >
                  <template v-slot:caret>
                    <span class="multiselect-caret">
                      <img :src="icon_caret" alt="" />
                    </span>
                  </template>
                </Multiselect>
                <div v-if="$v.form_portfolio.type.$dirty">
                  <b-form-invalid-feedback
                    :state="$v.form_portfolio.type.required"
                  >
                    Required Field
                  </b-form-invalid-feedback>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="form-group">
                <label>Amount</label>
                <input
                  v-model="form_portfolio.amount"
                  type="text"
                  placeholder="Amount"
                  class="form-control"
                />
                <div v-if="$v.form_portfolio.amount.$dirty">
                  <b-form-invalid-feedback
                    :state="$v.form_portfolio.amount.required"
                  >
                    Required Field
                  </b-form-invalid-feedback>
                </div>
              </div>
            </div>
          </div>

          <AlertInformation
            v-if="edit && dif_initial_current != 0 && dif_initial_current"
            class="col-12 mb-2"
            title="Hey"
            :description="description_alert"
          />
          <AlertInformation
            v-if="showTransferAlert"
            class="col-12 mb-2"
            title="Hey"
            :description="transferMessage"
          />
          <div class="row">
            <div class="col-6">
              <div class="form-check d-flex">
                <input
                  v-model="form_portfolio.ignore_transaction"
                  class="checkbox"
                  type="checkbox"
                  id="register"
                />
                <label for="register" class="label-checkbox">
                  Ignore transaction
                </label>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-end">
            <button v-if="isServiceLoading">
              <b-spinner small type="grow" variant="light"></b-spinner>
            </button>
            <button v-else @click="handlePortfolio">Save</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AlertInformation from "../../../commons/alerts/AlertInformation.vue";
import closeIcon from "../../../../assets/images/close.svg";
import number_formatter from "../../../../helpers/formatters/number_formatter";
import IconCaret from "../../../../../public/common/select-arrow-down.svg";
import Multiselect from "@vueform/multiselect/dist/multiselect.vue2";

import $ from "jquery";
import { mapState } from "vuex";
import { Modal } from "bootstrap";
import { required, requiredIf } from "vuelidate/lib/validators";

export default {
  name: "PortfolioModal",
  components: {
    AlertInformation,
    Multiselect,
  },
  props: ["edit", "demo", "showModal"],
  data() {
    return {
      close_icon: closeIcon,
      dif_initial_current: null,
      error: `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="20" height="20" rx="10" fill="#DC3545" fill-opacity="0.3"/>
          <path d="M12.4999 7.49992C12.4218 7.42181 12.3158 7.37793 12.2053 7.37793C12.0949 7.37793 11.9889 7.42181 11.9108 7.49992L9.99992 9.41076L8.08909 7.49992C8.01095 7.42181 7.90499 7.37793 7.79451 7.37793C7.68402 7.37793 7.57806 7.42181 7.49992 7.49992C7.42181 7.57806 7.37793 7.68402 7.37793 7.79451C7.37793 7.90499 7.42181 8.01095 7.49992 8.08909L9.41076 9.99992L7.49992 11.9108C7.42181 11.9889 7.37793 12.0949 7.37793 12.2053C7.37793 12.3158 7.42181 12.4218 7.49992 12.4999C7.57806 12.578 7.68402 12.6219 7.79451 12.6219C7.90499 12.6219 8.01095 12.578 8.08909 12.4999L9.99992 10.5891L11.9108 12.4999C11.9889 12.578 12.0949 12.6219 12.2053 12.6219C12.3158 12.6219 12.4218 12.578 12.4999 12.4999C12.578 12.4218 12.6219 12.3158 12.6219 12.2053C12.6219 12.0949 12.578 11.9889 12.4999 11.9108L10.5891 9.99992L12.4999 8.08909C12.578 8.01095 12.6219 7.90499 12.6219 7.79451C12.6219 7.68402 12.578 7.57806 12.4999 7.49992Z" fill="#1D1E25"/>
          </svg> Error`,
      icon_caret: IconCaret,
      showConnectionModal: false,
      success: `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="20" height="20" rx="10" fill="#8BF125" fill-opacity="0.3"/>
              <g clip-path="url(#clip0_1634_940)">
              <path d="M14.2995 6.84625L8.5416 12.6038C8.50288 12.6426 8.45688 12.6735 8.40622 12.6945C8.35556 12.7155 8.30124 12.7264 8.24639 12.7264C8.19153 12.7264 8.13722 12.7155 8.08656 12.6945C8.0359 12.6735 7.98989 12.6426 7.95118 12.6038L5.72451 10.375C5.6858 10.3361 5.63979 10.3053 5.58913 10.2843C5.53848 10.2632 5.48416 10.2524 5.4293 10.2524C5.37445 10.2524 5.32013 10.2632 5.26947 10.2843C5.21881 10.3053 5.17281 10.3361 5.1341 10.375C5.09523 10.4137 5.06439 10.4597 5.04335 10.5104C5.02231 10.561 5.01147 10.6154 5.01147 10.6702C5.01147 10.7251 5.02231 10.7794 5.04335 10.83C5.06439 10.8807 5.09523 10.9267 5.1341 10.9654L7.3616 13.1925C7.59657 13.427 7.91501 13.5588 8.24701 13.5588C8.57901 13.5588 8.89745 13.427 9.13243 13.1925L14.8899 7.43625C14.9287 7.39755 14.9595 7.35157 14.9805 7.30095C15.0015 7.25033 15.0123 7.19606 15.0123 7.14125C15.0123 7.08645 15.0015 7.03218 14.9805 6.98156C14.9595 6.93094 14.9287 6.88496 14.8899 6.84625C14.8512 6.80739 14.8052 6.77655 14.7546 6.75551C14.7039 6.73446 14.6496 6.72363 14.5947 6.72363C14.5399 6.72363 14.4855 6.73446 14.4349 6.75551C14.3842 6.77655 14.3382 6.80739 14.2995 6.84625Z" fill="#1D1E25"/>
              </g>
              <defs>
              <clipPath id="clip0_1634_940">
              <rect width="10" height="10" fill="white" transform="translate(5 5)"/>
              </clipPath>
              </defs>
              </svg> Success`,
    };
  },
  validations: {
    form_portfolio: {
      name: { required },
      group_token: { required },
      exchange_token: { required },
      type: {
        required: requiredIf(function (nestedModel) {
          return !this.isEdit();
        }),
      },
      amount: {
        required: requiredIf(function (nestedModel) {
          return !this.isEdit();
        }),
      },
    },
  },
  created() {
    this.$store.dispatch("groups/groups_selector");
  },
  mounted() {
    this.modal = new Modal(this.$refs.portfolioModal);
    const self = this;
    $("#portfolioModal").on("hide.bs.modal", function (event) {
      self.$store.commit("portfolios/set_creation_form");
      self.$emit("showInvestorModal");
      self.$store.commit("investors_v2/set_edit_investor_modal", true);
    });
  },
  computed: {
    ...mapState("connections", ["connection_list_selector", "connection_list"]),
    ...mapState("portfolios", [
      "current_balance",
      "form_portfolio",
      "portfolio_list",
      "create_portfolio",
      "update_portfolio",
    ]),
    ...mapState("groups", ["groups_selector"]),

    connection_options() {
      return this.connection_list && this.connection_list._data
        ? this.connection_list._data.data
        : null;
    },
    selected_connection_nav() {
      const connections = this.connection_options;
      const foundConnection = connections.find(
        (element) => element.token === this.form_portfolio.exchange_token
      );
      if (foundConnection) {
        return this.formatter(foundConnection.nav);
      } else {
        return "";
      }
    },
    description_alert() {
      return this.dif_initial_current > 0
        ? "This will be recorded as an approximate transfer in of " +
            this.formatter(this.dif_initial_current)
        : "This will be recorded as an approximate transfer out for " +
            this.formatter(this.dif_initial_current);
    },
    showTransferAlert() {
      return (
        this.form_portfolio.amount && !this.form_portfolio.ignore_transaction
      );
    },
    transferMessage() {
      const transferAmount = this.getTransferAmount();
      return this.getTransferMessage(transferAmount);
    },
    group_options() {
      return this.groups_selector && this.groups_selector._data
        ? this.groups_selector._data.data
        : null;
    },
    isTypePercentage() {
      return (
        this.form_portfolio.type == "percentage" &&
        this.form_portfolio.amount &&
        this.form_portfolio.exchange_token
      );
    },
    calculated_amount() {
      const nav = this.selected_connection_nav;
      return (nav * this.form_portfolio.amount) / 100;
    },

    typesOptions() {
      const types = [];
      this.addFixedType(types)({ name: "Fixed", value: "fixed" });
      this.addPercentageType(types)({
        name: "Percentage",
        value: "percentage",
      });
      return types;
    },
    isRemaining() {
      return this.form_portfolio.is_remaining;
    },
    isDemo() {
      return this.demo;
    },
    isNotDemoNotRemaining() {
      return !this.isDemo && !this.isRemaining;
    },
    isPercentage() {
      return this.form_portfolio.type == "percentage";
    },
    isServiceLoading() {
      return (
        this.create_portfolio._status._on_loading ||
        this.update_portfolio._status._on_loading
      );
    },
  },
  methods: {
    getTransferMessage(amount) {
      return (
        "This will be recorded as an approximate transfer " +
        (amount < 0 ? " in a " : " out ") +
        " for " +
        this.formatter(Math.abs(amount))
      );
    },
    getTransferAmount() {
      if (this.isPercentage && !this.form_portfolio.exchange_token) {
        return 0;
      }
      const oldNav = this.isEdit() ? this.form_portfolio.nav : 0;
      const newNav = this.isPercentage
        ? this.calculated_amount
        : this.form_portfolio.amount;
      return this.findNavDifference(oldNav, newNav);
    },
    findNavDifference(a, b) {
      return a - b;
    },
    isEdit() {
      return this.edit;
    },
    setDefaultType() {
      if (this.isDemo || this.isRemaining) {
        this.form_portfolio.type = "fixed";
      } else if (!this.isDemo && !this.isRemaining) {
        this.form_portfolio.type = "percentage";
      }
    },
    addFixedType(types) {
      return (type) => {
        types.push(type);
      };
    },
    addPercentageType(types) {
      return (type) => {
        if (this.isNotDemoNotRemaining) {
          types.push(type);
        }
      };
    },
    closeModal() {
      this.modal.hide();
    },
    createPortfolio() {
      this.$store.dispatch("portfolios/create_portfolio", {
        callback: ({ response }) => {
          if (response.error) {
            if (response.message) {
              this.$toastr.error(`${response.message}`, `${this.error}`);
            }
          } else {
            this.$toastr.success(
              "Portfolio created successfully.",
              `${this.success}`
            );
            this.modal.hide();
            this.$store.dispatch("portfolios/portfolio_list");
          }
        },
        error: ({ response }) => {
          if (response.data.message) {
            this.$toastr.error(`${response.data.message}`, `${this.error}`);
          }
        },
      });
    },
    deletePortfolio(id) {
      const body = {
        token: id.id,
      };

      Swal.fire({
        title: "Are you sure?",
        input: "checkbox",
        inputValue: 0,
        inputPlaceholder: "Register this as a transaction",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#1c2030",
        confirmButtonText: "Delete",
        preConfirm: async (value) => {
          body.is_transaction = value;
          await this.performDeletePortfolio(body);
        },
      }).then(async (result) => {
        if (result.data) {
        }
      });
    },
    formatter(number) {
      return number_formatter(number);
    },
    handlePortfolio() {
      this.$v.form_portfolio.$touch();
      let validData =
        this.$v.form_portfolio.name.$invalid ||
        this.$v.form_portfolio.group_token.$invalid ||
        this.$v.form_portfolio.exchange_token.$invalid ||
        this.$v.form_portfolio.type.$invalid ||
        this.$v.form_portfolio.amount.$invalid;
      if (validData) {
        this.$toastr.error("Please complete the fields.", `${this.error}`);
        return;
      } else {
        if (this.edit) {
          this.updatePortfolio();
        } else {
          this.createPortfolio();
        }
      }

      return;
    },
    async performDeletePortfolio(body) {
      return new Promise((resolve) => {
        this.$store.dispatch("portfolios/delete_portfolio", {
          callback: ({ response }) => {
            if (response.error) {
              this.$toastr.error(`${response.message}`, `${this.error}`);
              return;
            } else {
              this.$toastr.success(
                "Portfolio deleted successfully.",
                `${this.success}`
              );
              this.$store.dispatch("portfolios/portfolio_list");
            }
            resolve();
          },
          body,
        });
      });
    },
    show() {
      if (this.modal) {
        this.modal.show();
      }
    },
    updateCurrentBalance(new_value) {
      this.dif_initial_current = new_value - this.current_balance;
    },
    updatePortfolio() {
      this.$store.dispatch("portfolios/update_portfolio", {
        callback: ({ response }) => {
          if (response.error) {
            if (response.message) {
              this.$toastr.error(`${response.message}`, `${this.error}`);
            }
          } else {
            this.$toastr.success(
              "Portfolio updated successfully.",
              `${this.success}`
            );
            this.$store.dispatch("portfolios/portfolio_list");
            this.modal.hide();
          }
        },
        error: ({ response }) => {
          if (response.data.message) {
            this.$toastr.error(`${response.data.message}`, `${this.error}`);
          }
        },
      });
    },
  },
  watch: {
    "form_portfolio.group_token"(value) {
      if (!value || this.edit) {
        return;
      }

      let group = this.group_options.find((e) => e.token == value);
      this.form_portfolio.name = group.name;
    },
    "form_portfolio.current_balance"(new_value) {
      if (this.edit) {
        this.updateCurrentBalance(new_value);
      }
    },
    showModal(value) {
      this.$v.form_portfolio.$reset();
      this.setDefaultType();
    },
  },
};
</script>

<style lang="scss">
@import "../../../../styles/pages/investors_list/portfolio_modal.scss";
</style>
